export const SAMPLE_VARIABLES = [
    // ── Borrower Information ──────────────────────────────────────────────────
    {
        key: 'borrower_name',
        label: 'Borrower Name',
        type: 'string',
        category: 'Borrower Info',
        description: 'Full legal name of the borrower',
    },
    {
        key: 'borrower_address',
        label: 'Borrower Address',
        type: 'string',
        category: 'Borrower Info',
        description: 'Registered address of the borrower',
    },
    {
        key: 'borrower_email',
        label: 'Borrower Email',
        type: 'string',
        category: 'Borrower Info',
        description: 'Primary email address',
    },
    {
        key: 'borrower_phone',
        label: 'Borrower Phone',
        type: 'string',
        category: 'Borrower Info',
        description: 'Contact phone number',
    },
    {
        key: 'co_borrower_name',
        label: 'Co-Borrower Name',
        type: 'string',
        category: 'Borrower Info',
        description: 'Full legal name of the co-borrower',
    },
    {
        key: 'co_borrower_address',
        label: 'Co-Borrower Address',
        type: 'string',
        category: 'Borrower Info',
        description: 'Registered address of the co-borrower',
    },
    {
        key: 'co_borrower_phone',
        label: 'Co-Borrower Phone',
        type: 'string',
        category: 'Borrower Info',
        description: 'Contact phone number of the co-borrower',
    },
    // ── Loan Details ──────────────────────────────────────────────────────────
    {
        key: 'loan_account_number',
        label: 'Loan Account Number',
        type: 'string',
        category: 'Loan Details',
        description: 'Unique loan account identifier',
    },
    {
        key: 'loan_amount',
        label: 'Loan Amount',
        type: 'number',
        category: 'Loan Details',
        description: 'Principal loan amount in ₹',
    },
    {
        key: 'outstanding_amount',
        label: 'Outstanding Amount',
        type: 'number',
        category: 'Loan Details',
        description: 'Current outstanding balance in ₹',
    },
    {
        key: 'emi_amount',
        label: 'EMI Amount',
        type: 'number',
        category: 'Loan Details',
        description: 'Monthly EMI amount in ₹',
    },
    {
        key: 'interest_rate',
        label: 'Interest Rate',
        type: 'number',
        category: 'Loan Details',
        description: 'Annual interest rate in %',
    },
    {
        key: 'loan_type',
        label: 'Loan Type',
        type: 'string',
        category: 'Loan Details',
        description: 'Type of loan (Personal, Home, Vehicle, etc.)',
    },
    // ── Dates ─────────────────────────────────────────────────────────────────
    {
        key: 'due_date',
        label: 'Due Date',
        type: 'date',
        category: 'Dates',
        description: 'Payment due date',
    },
    {
        key: 'disbursement_date',
        label: 'Disbursement Date',
        type: 'date',
        category: 'Dates',
        description: 'Date when loan was disbursed',
    },
    {
        key: 'notice_date',
        label: 'Notice Date',
        type: 'date',
        category: 'Dates',
        description: 'Date of this notice',
    },
    // ── Guarantor ─────────────────────────────────────────────────────────────
    {
        key: 'guarantor_name',
        label: 'Guarantor Name',
        type: 'string',
        category: 'Guarantor',
        description: 'Full name of the guarantor',
    },
    {
        key: 'guarantor_address',
        label: 'Guarantor Address',
        type: 'string',
        category: 'Guarantor',
        description: 'Address of the guarantor',
    },
    // ── Legal ─────────────────────────────────────────────────────────────────
    {
        key: 'arbitration_venue',
        label: 'Arbitration Venue',
        type: 'string',
        category: 'Legal',
        description: 'City/Court for arbitration proceedings',
    },
    {
        key: 'days_overdue',
        label: 'Days Overdue',
        type: 'number',
        category: 'Legal',
        description: 'Number of days past due date',
    },
    {
        key: 'dpd_bucket',
        label: 'DPD Bucket',
        type: 'string',
        category: 'Legal',
        description: 'Days Past Due bucket (30+, 60+, 90+)',
    },
];
/**
 * Groups variables by their category for sidebar display.
 */
export function groupVariablesByCategory(variables) {
    const seen = new Set();
    const groups = (variables || []).reduce((acc, variable) => {
        let category = variable.category ?? 'Document Variables';
        if (typeof category === 'string' && category.toLowerCase() === 'other') {
            category = 'Document Variables';
        }
        const norm = (variable.label || variable.key || '').trim().toLowerCase();
        const id = `${category}:${norm}`;
        if (norm && seen.has(id)) {
            return acc;
        }
        if (norm) {
            seen.add(id);
        }
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push({ ...variable, category });
        return acc;
    }, {});

    const priority = ['Document Variables', 'Created Variables', 'Excel Data'];
    const sortedKeys = Object.keys(groups).sort((a, b) => {
        const idxA = priority.indexOf(a);
        const idxB = priority.indexOf(b);
        if (idxA !== -1 && idxB !== -1) return idxA - idxB;
        if (idxA !== -1) return -1;
        if (idxB !== -1) return 1;
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });

    const sortedGroups = {};
    sortedKeys.forEach(k => {
        sortedGroups[k] = groups[k].sort((a, b) => (a.label || a.key || '').localeCompare(b.label || b.key || '', undefined, { numeric: true, sensitivity: 'base' }));
    });
    return sortedGroups;
}
